<template>
    <div v-if="active" :class="{christmas: true, mobile: mobile()}">
        <a v-show="! infoOpen" href="#" class="close" @click="close()"></a>
        <full-page ref="fullpage" :options="options" @after-load="afterLoad">
          <Intro ref="intro" @next="nextScene(0)"/>
            <Tutorial ref="tutorial" @next="nextScene(1)"/>
            <Start @next="nextScene(2)"/>
            <Prophecies @next="nextScene(3)"/>
            <Trip @next="nextScene(4)"/>
            <Barn @next="nextScene(5)"/>
            <Angels @next="nextScene(6)"/>
            <Shepherds @next="nextScene(7)"/>
            <OrderBook @next="nextScene(8)" @close="close()" @order="openOrder()"/>
        </full-page>
        <img v-show="(! infoOpen) && infoButtonActive()" src="@/assets/christmas/infoIcon.svg" id="infoButton" class="infoIcon pulse" @click="openInfo">
        <Info ref="info" :open="infoOpen" @close="closeInfo()" :infoArray="info"/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import answers from "@/assets/answers";
    import Headline from "@/components/Headline";
    import BackButton from "@/components/BackButton";
    import Scene from "@/components/christmas/Scene";
    import Start from "@/components/christmas/Start";
    import Tutorial from "@/components/christmas/Tutorial";
    import Prophecies from "@/components/christmas/Prophecies";
    import Trip from "@/components/christmas/Trip";
    import Barn from "@/components/christmas/Barn";
    import Angels from "@/components/christmas/Angels";
    import Shepherds from "@/components/christmas/Shepherds";
    import Poll from "@/components/christmas/Poll";
    import BasicComponent from "@/components/BasicComponent";
    import Info from "@/components/christmas/Info";
    import Intro from "@/components/christmas/Intro";
    import OrderBook from "@/components/christmas/OrderBook";

    @Component({
        components: {
          OrderBook,
          Intro,
          Info, Poll, Shepherds, Angels, Barn, Trip, Prophecies, Tutorial, Start, Scene, BackButton, Headline},
    })
    export default class Christmas extends BasicComponent {

        data() {
            return {
                active: false,
                index: 0,
                infoOpen: false,
                pageBefore: null,

                indexToArticles: { // Welche Artikel zu welcher Slide gehören
                    2: [0, 1],
                    3: [2],
                    4: [3],
                    5: [4, 5],
                    6: [6]
                },
                slides: [
                    "Tutorial",
                    "Start",
                    "Prophezeiungen",
                    "Wanderung",
                    "Stall",
                    "Engel",
                    "Hirten",
                    "Umfrage"
                ],
                info: [
                    {
                        title: "Prophezeiungen?",
                        lastOfType: false
                    },
                    {
                        title: "Jesus als historische Person",
                        lastOfType: true
                    },
                    {
                        title: "Jungfrauengeburt",
                        lastOfType: true
                    },
                    {
                        title: "Der Stall",
                        lastOfType: true
                    },
                    {
                        title: "Wovor rettet Jesus?",
                        lastOfType: false
                    },
                    {
                        title: "Warum Hirten?",
                        lastOfType: true
                    },
                    {
                        title: "Gute Nachricht?",
                        lastOfType: false
                    }
                ],

                options: {
                    licenseKey: "381A4FF0-3A544E43-878AC729-E8EDDCD1",
                    afterLoad: this.afterLoad,
                    normalScrollElements: "#infoContent, #pollThanks, #book-order",
                }
            };
        }


        created() {
            if (this.$cookie.get("christmas") === "closed") {
                this.$data.active = false;
                return;
            }
            //this.open();
        }

        mounted() {
        }

        infoButtonActive() {
            return this.index > 2 && this.index < 8;
        }

        animateInfoButton() {
            const el = document.getElementById("infoButton");
            setTimeout(() => {
                el.classList.remove("pulse");
            }, 2000);
        }

        close() {
            this.$data.active = false;
            this.$cookie.set("christmas", "closed", {expires: 30});
            this.trackPage("/")
            this.trackEvent('Weihnachten', "Weihnachtsseite geschlossen");
        }

        open() {
            this.$data.active = true;
            this.$cookie.delete("christmas");
            this.trackPage("Weihnachten")
        }

        openInfo() {
            const index = this.$data.index;
            const articles = this.$data.indexToArticles[index];
            const info = this.$refs.info;
            info.openArticles(articles);
            this.$data.infoOpen = true;
            this.$data.pageBefore = this.getCurrentPageName();
        }

        closeInfo() {
            this.$data.infoOpen = false;
            this.trackPage("Weihnachten")
            this.trackPage(this.getCurrentPageName());
            this.trackEvent('Weihnachten - Zusatzinfos geschlossen', this.info[index].title);
        }

        getCurrentPageName() {
            return "Weihnachten - " + this.slides[this.$data.index];
        }

        afterLoad(origin, destination, direction) {
            const index = destination.index;
            this.$data.index = index;
            this.$refs.fullpage.$children[index].onActive();
            this.trackPage(this.getCurrentPageName());
            this.trackEvent('Weihnachten - Folie aufgerufen', this.slides[index]);
            if (this.mobile() && this.infoButtonActive()) {
                document.getElementById("infoButton").classList.add("pulse");
                this.animateInfoButton();
            }
            if (index !== 3) {
                const buttonLine = document.getElementById("buttonLine"); // hide button line
                if (! buttonLine.classList.contains("invisible")) buttonLine.classList.add("invisible");
            }
        }

        nextScene(source) {
            if (this.index !== source) return;
            this.$refs.fullpage.api.moveSectionDown();
        }

        previousScene() {
            this.$refs.fullpage.api.moveSectionUp();
        }

        openOrder() {
          this.$emit("order");
        }

    }
</script>
<style scoped lang="scss">

    .christmas {
        height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;

        z-index: 1000;
        background-color: white;
    }

    .close {
        position: absolute;
        right: 32px;
        top: 32px;
        width: 32px;
        height: 32px;
        opacity: 0.3;
        z-index: 3000;
    }
    .close:hover {
        opacity: 1;
    }
    .close:before, .close:after {
        position: absolute;
        left: 15px;
        content: ' ';
        height: 33px;
        width: 2px;
        background-color: #333;
    }
    .close:before {
        transform: rotate(45deg);
    }
    .close:after {
        transform: rotate(-45deg);
    }

    .infoIcon {
        position: fixed;
        bottom: 0;
        right: 0;
        transform: translate(25%, 25%);

        &:hover {
            cursor: pointer;
        }
    }


</style>
<style lang="scss">

    .christmas {
        * {
            font-variant: normal !important;
            font-weight: 600;
        }

        .pulse {
            -webkit-animation-name: pulsate;
            -webkit-animation-duration: 1s;
            -webkit-animation-timing-function: ease-in-out;
            -webkit-animation-iteration-count: infinite
        }

        @-webkit-keyframes pulsate {
            0% { transform: scale(1.0) translate(25%, 25%)}
            10% { transform: scale(1.05) translate(24%, 24%) }
            20% { transform: scale(1.10) translate(23%, 23%) }
            30% { transform: scale(1.15) translate(22%, 22%) }
            40% { transform: scale(1.20) translate(21%, 21%) }
            50% { transform: scale(1.25) translate(20%, 20%) }
            60% { transform: scale(1.20) translate(21%, 21%) }
            70% { transform: scale(1.15) translate(22%, 22%) }
            80% { transform: scale(1.10) translate(23%, 23%) }
            90% { transform: scale(1.05) translate(24%, 24%) }
            100% { transform: scale(1.0) translate(25%, 25%) }
        }
    }

</style>
